module.exports = __webpack_public_path__ + "img/成都办公室1.71040e2a.jpg";